<template>
    <div class="form-group__wrapper">
        <label :for="slug" class="form-group__label" :class="{ disabled: isDisabled, isSmall: isSmallLabel }">
            {{ label }}:
            <div v-if="description" class="form-group__tooltip">
                <IconTooltip :tooltipMessage="description" :isHtml="true"></IconTooltip>
            </div>
        </label>
        <VueMultiselect
            className="filterMultiselect"
            v-model="selectedValues"
            maxHeight="85"
            :options="filterValues"
            label="title"
            :hide-selected="true"
            track-by="title"
            :searchable="false"
            :multiple="true"
            openDirection="bottom"
            :closeOnSelect="true"
            :showPointer="false"
            @select="handleSelectedValues"
            @remove="handleSelectedValues"
        ></VueMultiselect>
    </div>
</template>

<script lang="ts">
import IconTooltip from 'Vue/components/lockDesigner/components/shared/IconTooltip.vue';
import VueMultiselect from 'vue-multiselect';
export default {
    name: 'MultiSelect',
    components: {
        IconTooltip,
        VueMultiselect,
    },
    props: {
        slug: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        hasInfoButton: {
            type: Boolean,
            default: false,
        },
        filterValues: {
            type: Array,
            required: true,
        },
        isSmallLabel: {
            type: Boolean,
            default: false,
        },
        showNumResults: {
            type: Boolean,
            default: false,
        },
        description: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            selectedValues: null,
            inputValue: '',
        };
    },
    watch: {
        filterValues: {
            handler: 'updateSelectedValue',
            deep: true,
        },
    },
    methods: {
        handleSelectedValues() {
            let selectedArray = JSON.parse(JSON.stringify(this.selectedValues)).map((item) => item.title);

            let filterValuesCopy = [...this.filterValues];

            filterValuesCopy = filterValuesCopy.map((option) => {
                return { ...option, isSelected: selectedArray.includes(option.title) };
            });

            let newOptions = JSON.parse(JSON.stringify(filterValuesCopy));
            this.$emit('filterChange', newOptions);
        },
        onInfoButtonClick() {
            this.$emit('infoButtonClick');
        },
        updateSelectedValue() {
            let filterValuesCopy = [...this.filterValues];
            // Set the selected value based on the isSelected property
            const selectedFilter = filterValuesCopy.filter((filterItem) => filterItem.isSelected);
            this.selectedValues = [...selectedFilter];
        },
    },
};
</script>
